import { Box } from '@mui/material';
import { useAuth } from 'contexts/authContext';
import { useNavigate } from 'react-router-dom';
import { reactPaths } from 'root/pathnames';
import { RatesTable } from './components/RatesTable/RatesTable';

export const RatesModule = () => {
  //TODO: Add privilages to remove this clientPanelUser check here
  const { user } = useAuth();
  const navigate = useNavigate();

  if (user?.clientPanelUser) {
    navigate(reactPaths.home);
  }

  return (
    <Box
      alignItems='center'
      display='flex'
      flexDirection='column'
      paddingTop='20px'
      sx={{ mx: 4 }}
    >
      <RatesTable />
    </Box>
  );
};
